<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="row align-items-center justify-content-center" id="main_block">
            <section class="col-lg-10 col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <h3>{{"CREATE_TRANSFORMATION" | translate}}</h3>
                                <p class="font-small-4">{{"START_TRANSFORMATION_INSTRUCTION" | translate}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="collaborator">{{'TITLES.USERS_TYPES_SINGULAR.collaborator' | translate}}</label>
                                <ng-select id="collaborator" [items]="collaboratorList" bindLabel="label" bindValue="hash" [closeOnSelect]="true"
                                           [clearable]="false" [(ngModel)]="collaboratorHash"></ng-select>
                            </div>
                            <div class="col-12 text-center mt-1">
                                <button class="btn btn-primary" (click)="transformCollaborateToEmployee(collaboratorHash)" [disabled]="!collaboratorHash ||collaboratorHash.length < 1">{{"START_TRANSFORMATION" | translate}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
